import script from "./YampiShoppingCartComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./YampiShoppingCartComponent.vue?vue&type=script&setup=true&lang=ts"

import "./YampiShoppingCartComponent.vue?vue&type=style&index=0&id=e4178692&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4178692"]])

export default __exports__